"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const LoadingButton = ({ children, isLoading = false, disabled = false, spinnerColorClass = 'text-light', }) => {
    const spinner = (0, react_1.useMemo)(() => ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('spinner-border spinner-border-sm', spinnerColorClass), role: "status", children: (0, jsx_runtime_1.jsx)("span", { className: "visually-hidden", children: "Loading..." }) })), [spinnerColorClass]);
    const button = (0, react_1.useMemo)(() => {
        const child = isLoading ? spinner : children.props.children;
        return (0, react_1.cloneElement)(children, { disabled: disabled || isLoading }, child);
    }, [isLoading, spinner, children, disabled]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: button });
};
exports.default = LoadingButton;
